import { RootState } from '@/App/store';

export const selectUiState = (state: RootState) => state.ui;
